<template>
  <div v-if="gamelist?.length && is_show == 1">
    <div
      class="flex justify-between items-center"
      style="margin-top: 0.1rem;margin-bottom: 0.2rem; font-size: 0.22rem"
    >
      <div class="flex items-center">
        <img :src="titleImg" style="height: 0.5rem" />
        <span
          style="
            color: var(--theme-text-color-darken);
            font-size: 0.35rem;
            font-weight: 500;
            margin-left: 0.1rem;
          "
          >{{ title }}</span
        >
      </div>
      <div
        class="flex justify-between items-center"
        style="height: 0.5rem; color: #fff;margin-right: 0.2rem;"
      >
        <div
          class="flex items-center justify-center"
          style="
            width: 0.4rem;
            height: 0.4rem;
            background-color: #fff3;
            border-radius: 0.11rem;
            margin-right: 0.1rem;
            cursor: pointer;
          "
          @click="previous"
        >
          <van-icon name="arrow-left" />
        </div>
        <div
          class="flex items-center justify-center"
          style="
            background-color: #fff3;
            border-radius: 0.11rem;
            width: 1.2rem;
            height: 0.4rem;
          "
        >
          {{ $t('_home._Todos') }} {{ gamelist?.length }}
        </div>
        <div
          class="flex items-center justify-center"
          style="
            width: 0.4rem;
            height: 0.4rem;
            background-color: #fff3;
            border-radius: 0.11rem;
            margin-left: 0.1rem;
            cursor: pointer;
          "
          @click="next"
        >
          <van-icon name="arrow" />
        </div>
        <div
          class="flex items-center justify-center"
          style="
            width: 0.6rem;
            height: 0.4rem;
            background-color: #fff3;
            border-radius: 0.11rem;
            margin-left: 0.1rem;
            cursor: pointer;
          "
          @click="openUrl('subgame', { category: 'slot', code: code })"
        >
          {{ $t('_home._Mais') }}
        </div>
      </div>
    </div>
    <van-tabs
      v-if="gamelist.length"
      v-model:active="activeIndex"
      :animated="true"
      :show-header="false"
    >
      <van-tab v-for="pageIndex in pageLength" :key="pageIndex">
        <el-row :gutter="12">
          <el-col
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0;
            "
            v-for="(item, index) in gamelist.slice(
              (pageIndex - 1) * showNum,
              (pageIndex - 1) * showNum + showNum
            )"
            :key="index"
            :span="24 / (showNum / showLine)"
          >
            <gameItem :category="item.name" :item="item" type="home"></gameItem>
          </el-col>
        </el-row>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import gameItem from '@/components/gameItem/index3.8_2.vue';
export default {
  components: {
    gameItem,
  },
  props: {
    is_show: {
      type: Number,
      defdefault: 1
    },
    title: {
      type: String,
      defdefault: ''
    },
    code: {
      type: String,
      defdefault: ''
    },
    titleImg: {
      type: String,
      defdefault: ''
    },
    gamelist: {
      type: Array,
      defdefault: []
    },
    showNum: {
      type: Number,
      default: 9
    },
    showLine: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      pageLength: 1,
      activeIndex: 0
    };
  },
  mounted() {
    this.getPageLength(this.gamelist);
  },
  methods: {
    previous() {
      if (this.activeIndex === 0) {
        // this.activeIndex = this.pageLength - 1;
        return;
      } else {
        this.activeIndex -= 1;
      }
    },
    next() {
      if (this.activeIndex === this.pageLength - 1) {
        // this.activeIndex = 0;
        return;
      } else {
        this.activeIndex += 1;
      }
    },
    getPageLength(arr) {
      if (arr) {
        // 使用 Math.ceil 正确向上取整
        let length = Math.ceil(arr.length / this.showNum);
        // 确保至少有1页
        this.pageLength = Math.max(1, length);
      }
    }
  }
};
</script>
<style scoped>
:deep(.van-tabs__wrap) {
  display: none !important;
}

:deep(.el-row) {
  box-sizing: border-box;
  padding: 0 0.03125rem;
}
</style>

<style>
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
</style>
